// Function to get the difference in days between two dates
export const getDaysBetweenDates = (startDate: Date, endDate: Date): number => {
    const timeDiff = endDate.getTime() - startDate.getTime();
    const daysDifference = Math.floor(timeDiff / (1000 * 3600 * 24)); // Convert to days
    return daysDifference;
}

// Check for days remaining until
export const getRemainingTimeToEndDate = (endDate: Date): number => {
    const currentDate = new Date();
    const daysRemaining = getDaysBetweenDates(currentDate, endDate);
    if(daysRemaining < -1){
        return 0
    }else if(daysRemaining === -1){
        return 1
    }else{
        return daysRemaining +2 
    }
}

